const jsonlint = require("jsonlint-mod");
window.jsonlint = jsonlint;

let constants = {

	codeMirrorOptionsJson: {
		theme: "default",
		height: "auto",
		viewportMargin: Infinity,
		mode: {
			name: "javascript",
			json: true,
			statementIndent: 2
		},
		lineNumbers: true,
		lineWrapping: false,
		foldGutter: true,
		gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"],
		indentWithTabs: false,
		tabSize: 2,
		styleActiveLine: true,
		lint: true
	},
	codeMirrorOptionsJs: {
		theme: "default",
		height: "auto",
		viewportMargin: Infinity,
		mode: {
			name: "javascript",
			statementIndent: 2
		},
		lineNumbers: true,
		lineWrapping: false,
		foldGutter: true,
		gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"],
		indentWithTabs: false,
		tabSize: 2,
		styleActiveLine: true,
		lint: true
	},
	textTracks: {
		langCodes: [
			{
				value: "ar",
				name: "Arabic"
			},
			{
				value: "ca",
				name: "Catalan"
			},
			{
				value: "zh-Hans",
				name: "Chinese (Simplified)"
			},
			{
				value: "zh-Hant",
				name: "Chinese (Traditional)"
			},
			{
				value: "cs",
				name: "Czech"
			},
			{
				value: "da",
				name: "Danish"
			},
			{
				value: "nl",
				name: "Dutch"
			},
			{
				value: "en",
				name: "English"
			},
			{
				value: "fi",
				name: "Finnish"
			},
			{
				value: "fr",
				name: "French"
			},
			{
				value: "de",
				name: "German"
			},
			{
				value: "el",
				name: "Greek"
			},
			{
				value: "he",
				name: "Hebrew"
			},
			{
				value: "hi",
				name: "Hindi"
			},
			{
				value: "hu",
				name: "Hungarian"
			},
			{
				value: "is",
				name: "Icelandic"
			},
			{
				value: "id",
				name: "Indonesian"
			},
			{
				value: "it",
				name: "Italian"
			},
			{
				value: "jp",
				name: "Japanese"
			},
			{
				value: "ko",
				name: "Korean"
			},
			{
				value: "ms",
				name: "Malay"
			},
			{
				value: "no",
				name: "Norwegian"
			},
			{
				value: "pl",
				name: "Polish"
			},
			{
				value: "pt",
				name: "Portuguese"
			},
			{
				value: "pa",
				name: "Punjabi"
			},
			{
				value: "ro",
				name: "Romanian"
			},
			{
				value: "sr",
				name: "Serbian"
			},
			{
				value: "es",
				name: "Spanish"
			},
			{
				value: "sv",
				name: "Swedish"
			},
			{
				value: "ta",
				name: "Tamil"
			},
			{
				value: "th",
				name: "Thai"
			},
			{
				value: "tr",
				name: "Turkish"
			},
			{
				value: "uk",
				name: "Ukranian"
			},
			{
				value: "vi",
				name: "Viatvaluese"
			}
		],
		kinds: [
			{
				value: "subtitles",
				name: "Subtitles"
			},
			{
				value: "captions",
				name: "Captions"
			},
			{
				value: "descriptions",
				name: "Descriptions"
			},
			{
				value: "chapters",
				name: "Chapters"
			},
			{
				value: "metadata",
				name: "Metadata"
			}
		]
	},
	audio: {
		tts: {
			pollyVoices: [
				{
					"Gender": "Female",
					"Id": "Isabelle",
					"LanguageCode": "fr-BE",
					"LanguageName": "Belgian French",
					"Name": "Isabelle",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Danielle",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Danielle",
					"SupportedEngines": [
						"generative",
						"long-form",
						"neural"
					],
					"SupportedEnginesList": "Generative, Long-Form, Neural"
				},
				{
					"Gender": "Male",
					"Id": "Gregory",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Gregory",
					"SupportedEngines": [
						"long-form",
						"neural"
					],
					"SupportedEnginesList": "Long-Form, Neural"
				},
				{
					"Gender": "Female",
					"Id": "Burcu",
					"LanguageCode": "tr-TR",
					"LanguageName": "Turkish",
					"Name": "Burcu",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Jitka",
					"LanguageCode": "cs-CZ",
					"LanguageName": "Czech",
					"Name": "Jitka",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Sabrina",
					"LanguageCode": "de-CH",
					"LanguageName": "Swiss Standard German",
					"Name": "Sabrina",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Patrick",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Patrick",
					"SupportedEngines": [
						"long-form"
					],
					"SupportedEnginesList": "Long-Form"
				},
				{
					"Gender": "Female",
					"Id": "Alba",
					"LanguageCode": "es-ES",
					"LanguageName": "Castilian Spanish",
					"Name": "Alba",
					"SupportedEngines": [
						"long-form"
					],
					"SupportedEnginesList": "Long-Form"
				},
				{
					"Gender": "Male",
					"Id": "Raul",
					"LanguageCode": "es-ES",
					"LanguageName": "Castilian Spanish",
					"Name": "Raul",
					"SupportedEngines": [
						"long-form"
					],
					"SupportedEnginesList": "Long-Form"
				},
				{
					"Gender": "Female",
					"Id": "Joanna",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Joanna",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Ruth",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Ruth",
					"SupportedEngines": [
						"generative",
						"long-form",
						"neural"
					],
					"SupportedEnginesList": "Generative, Long-Form, Neural"
				},
				{
					"Gender": "Female",
					"Id": "Lupe",
					"LanguageCode": "es-US",
					"LanguageName": "US Spanish",
					"Name": "Lupe",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Jasmine",
					"LanguageCode": "en-SG",
					"LanguageName": "Singaporean English",
					"Name": "Jasmine",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Jihye",
					"LanguageCode": "ko-KR",
					"LanguageName": "Korean",
					"Name": "Jihye",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Kevin",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Kevin",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Filiz",
					"LanguageCode": "tr-TR",
					"LanguageName": "Turkish",
					"Name": "Filiz",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Elin",
					"LanguageCode": "sv-SE",
					"LanguageName": "Swedish",
					"Name": "Elin",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Astrid",
					"LanguageCode": "sv-SE",
					"LanguageName": "Swedish",
					"Name": "Astrid",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Tatyana",
					"LanguageCode": "ru-RU",
					"LanguageName": "Russian",
					"Name": "Tatyana",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Maxim",
					"LanguageCode": "ru-RU",
					"LanguageName": "Russian",
					"Name": "Maxim",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Carmen",
					"LanguageCode": "ro-RO",
					"LanguageName": "Romanian",
					"Name": "Carmen",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Ines",
					"LanguageCode": "pt-PT",
					"LanguageName": "Portuguese",
					"Name": "Inês",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Cristiano",
					"LanguageCode": "pt-PT",
					"LanguageName": "Portuguese",
					"Name": "Cristiano",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Vitoria",
					"LanguageCode": "pt-BR",
					"LanguageName": "Brazilian Portuguese",
					"Name": "Vitória",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Ricardo",
					"LanguageCode": "pt-BR",
					"LanguageName": "Brazilian Portuguese",
					"Name": "Ricardo",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Camila",
					"LanguageCode": "pt-BR",
					"LanguageName": "Brazilian Portuguese",
					"Name": "Camila",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Maja",
					"LanguageCode": "pl-PL",
					"LanguageName": "Polish",
					"Name": "Maja",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Jan",
					"LanguageCode": "pl-PL",
					"LanguageName": "Polish",
					"Name": "Jan",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Jacek",
					"LanguageCode": "pl-PL",
					"LanguageName": "Polish",
					"Name": "Jacek",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Ewa",
					"LanguageCode": "pl-PL",
					"LanguageName": "Polish",
					"Name": "Ewa",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Ola",
					"LanguageCode": "pl-PL",
					"LanguageName": "Polish",
					"Name": "Ola",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Lisa",
					"LanguageCode": "nl-BE",
					"LanguageName": "Belgian Dutch",
					"Name": "Lisa",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Ruben",
					"LanguageCode": "nl-NL",
					"LanguageName": "Dutch",
					"Name": "Ruben",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Lotte",
					"LanguageCode": "nl-NL",
					"LanguageName": "Dutch",
					"Name": "Lotte",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Laura",
					"LanguageCode": "nl-NL",
					"LanguageName": "Dutch",
					"Name": "Laura",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Ida",
					"LanguageCode": "nb-NO",
					"LanguageName": "Norwegian",
					"Name": "Ida",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Liv",
					"LanguageCode": "nb-NO",
					"LanguageName": "Norwegian",
					"Name": "Liv",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Seoyeon",
					"LanguageCode": "ko-KR",
					"LanguageName": "Korean",
					"Name": "Seoyeon",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Kazuha",
					"LanguageCode": "ja-JP",
					"LanguageName": "Japanese",
					"Name": "Kazuha",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Tomoko",
					"LanguageCode": "ja-JP",
					"LanguageName": "Japanese",
					"Name": "Tomoko",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Takumi",
					"LanguageCode": "ja-JP",
					"LanguageName": "Japanese",
					"Name": "Takumi",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Mizuki",
					"LanguageCode": "ja-JP",
					"LanguageName": "Japanese",
					"Name": "Mizuki",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Bianca",
					"LanguageCode": "it-IT",
					"LanguageName": "Italian",
					"Name": "Bianca",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Giorgio",
					"LanguageCode": "it-IT",
					"LanguageName": "Italian",
					"Name": "Giorgio",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Carla",
					"LanguageCode": "it-IT",
					"LanguageName": "Italian",
					"Name": "Carla",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Karl",
					"LanguageCode": "is-IS",
					"LanguageName": "Icelandic",
					"Name": "Karl",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Dora",
					"LanguageCode": "is-IS",
					"LanguageName": "Icelandic",
					"Name": "Dóra",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Mathieu",
					"LanguageCode": "fr-FR",
					"LanguageName": "French",
					"Name": "Mathieu",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Lea",
					"LanguageCode": "fr-FR",
					"LanguageName": "French",
					"Name": "Léa",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Celine",
					"LanguageCode": "fr-FR",
					"LanguageName": "French",
					"Name": "Céline",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Chantal",
					"LanguageCode": "fr-CA",
					"LanguageName": "Canadian French",
					"Name": "Chantal",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Gabrielle",
					"LanguageCode": "fr-CA",
					"LanguageName": "Canadian French",
					"Name": "Gabrielle",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Penelope",
					"LanguageCode": "es-US",
					"LanguageName": "US Spanish",
					"Name": "Penélope",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Miguel",
					"LanguageCode": "es-US",
					"LanguageName": "US Spanish",
					"Name": "Miguel",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Mia",
					"LanguageCode": "es-MX",
					"LanguageName": "Mexican Spanish",
					"Name": "Mia",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Lucia",
					"LanguageCode": "es-ES",
					"LanguageName": "Castilian Spanish",
					"Name": "Lucia",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Enrique",
					"LanguageCode": "es-ES",
					"LanguageName": "Castilian Spanish",
					"Name": "Enrique",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Conchita",
					"LanguageCode": "es-ES",
					"LanguageName": "Castilian Spanish",
					"Name": "Conchita",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Geraint",
					"LanguageCode": "en-GB-WLS",
					"LanguageName": "Welsh English",
					"Name": "Geraint",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Salli",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Salli",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Matthew",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Matthew",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Kimberly",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Kimberly",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Kendra",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Kendra",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Justin",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Justin",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Joey",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Joey",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Ivy",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Ivy",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Aria",
					"LanguageCode": "en-NZ",
					"LanguageName": "New Zealand English",
					"Name": "Aria",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Ayanda",
					"LanguageCode": "en-ZA",
					"LanguageName": "South African English",
					"Name": "Ayanda",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Female",
					"Id": "Raveena",
					"LanguageCode": "en-IN",
					"LanguageName": "Indian English",
					"Name": "Raveena",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Aditi",
					"LanguageCode": "en-IN",
					"LanguageName": "Indian English",
					"Name": "Aditi",
					"AdditionalLanguageCodes": [
						"hi-IN"
					],
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Emma",
					"LanguageCode": "en-GB",
					"LanguageName": "British English",
					"Name": "Emma",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Brian",
					"LanguageCode": "en-GB",
					"LanguageName": "British English",
					"Name": "Brian",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Amy",
					"LanguageCode": "en-GB",
					"LanguageName": "British English",
					"Name": "Amy",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Male",
					"Id": "Russell",
					"LanguageCode": "en-AU",
					"LanguageName": "Australian English",
					"Name": "Russell",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Nicole",
					"LanguageCode": "en-AU",
					"LanguageName": "Australian English",
					"Name": "Nicole",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Olivia",
					"LanguageCode": "en-AU",
					"LanguageName": "Australian English",
					"Name": "Olivia",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Female",
					"Id": "Vicki",
					"LanguageCode": "de-DE",
					"LanguageName": "German",
					"Name": "Vicki",
					"SupportedEngines": [
						"generative",
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Generative, Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Marlene",
					"LanguageCode": "de-DE",
					"LanguageName": "German",
					"Name": "Marlene",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Hans",
					"LanguageCode": "de-DE",
					"LanguageName": "German",
					"Name": "Hans",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Naja",
					"LanguageCode": "da-DK",
					"LanguageName": "Danish",
					"Name": "Naja",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Male",
					"Id": "Mads",
					"LanguageCode": "da-DK",
					"LanguageName": "Danish",
					"Name": "Mads",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Sofie",
					"LanguageCode": "da-DK",
					"LanguageName": "Danish",
					"Name": "Sofie",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Gwyneth",
					"LanguageCode": "cy-GB",
					"LanguageName": "Welsh",
					"Name": "Gwyneth",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Zhiyu",
					"LanguageCode": "cmn-CN",
					"LanguageName": "Chinese Mandarin",
					"Name": "Zhiyu",
					"SupportedEngines": [
						"neural",
						"standard"
					],
					"SupportedEnginesList": "Neural, Standard"
				},
				{
					"Gender": "Female",
					"Id": "Zeina",
					"LanguageCode": "arb",
					"LanguageName": "Arabic",
					"Name": "Zeina",
					"SupportedEngines": [
						"standard"
					],
					"SupportedEnginesList": "Standard"
				},
				{
					"Gender": "Female",
					"Id": "Hala",
					"LanguageCode": "ar-AE",
					"LanguageName": "Gulf Arabic",
					"Name": "Hala",
					"AdditionalLanguageCodes": [
						"arb"
					],
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Arlet",
					"LanguageCode": "ca-ES",
					"LanguageName": "Catalan",
					"Name": "Arlet",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Hannah",
					"LanguageCode": "de-AT",
					"LanguageName": "Austrian German",
					"Name": "Hannah",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Stephen",
					"LanguageCode": "en-US",
					"LanguageName": "US English",
					"Name": "Stephen",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Female",
					"Id": "Kajal",
					"LanguageCode": "en-IN",
					"LanguageName": "Indian English",
					"Name": "Kajal",
					"AdditionalLanguageCodes": [
						"hi-IN"
					],
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Female",
					"Id": "Hiujin",
					"LanguageCode": "yue-CN",
					"LanguageName": "Cantonese",
					"Name": "Hiujin",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Suvi",
					"LanguageCode": "fi-FI",
					"LanguageName": "Finnish",
					"Name": "Suvi",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Female",
					"Id": "Niamh",
					"LanguageCode": "en-IE",
					"LanguageName": "Irish English",
					"Name": "Niamh",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Arthur",
					"LanguageCode": "en-GB",
					"LanguageName": "British English",
					"Name": "Arthur",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Daniel",
					"LanguageCode": "de-DE",
					"LanguageName": "German",
					"Name": "Daniel",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Male",
					"Id": "Liam",
					"LanguageCode": "fr-CA",
					"LanguageName": "Canadian French",
					"Name": "Liam",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Pedro",
					"LanguageCode": "es-US",
					"LanguageName": "US Spanish",
					"Name": "Pedro",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Male",
					"Id": "Sergio",
					"LanguageCode": "es-ES",
					"LanguageName": "Castilian Spanish",
					"Name": "Sergio",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Male",
					"Id": "Andres",
					"LanguageCode": "es-MX",
					"LanguageName": "Mexican Spanish",
					"Name": "Andrés",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Male",
					"Id": "Remi",
					"LanguageCode": "fr-FR",
					"LanguageName": "French",
					"Name": "Rémi",
					"SupportedEngines": [
						"generative",
						"neural"
					],
					"SupportedEnginesList": "Generative, Neural"
				},
				{
					"Gender": "Male",
					"Id": "Adriano",
					"LanguageCode": "it-IT",
					"LanguageName": "Italian",
					"Name": "Adriano",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Thiago",
					"LanguageCode": "pt-BR",
					"LanguageName": "Brazilian Portuguese",
					"Name": "Thiago",
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				},
				{
					"Gender": "Male",
					"Id": "Zayd",
					"LanguageCode": "ar-AE",
					"LanguageName": "Gulf Arabic",
					"Name": "Zayd",
					"AdditionalLanguageCodes": [
						"arb"
					],
					"SupportedEngines": [
						"neural"
					],
					"SupportedEnginesList": "Neural"
				}
			],
			generationParams: {
				SAMPLE_RATE: "ttsAudioGenerationSampleRate",
				VOICE_ID: "ttsAudioGenerationVoiceId",
				VOICE: "ttsAudioGenerationVoice",
				ENGINE: "ttsAudioGenerationEngine"
			}
		}
	},
	react: {
		components: {
			reactModal: {
				zIndex: 1002
			}
		}
	},
	experiencesInventory: {
		props: ["id", "visible"]
	},
	activity: {
		metadata: {
			props: [
				"id",
				"name",
				"description",
				"genre",
				"publisher",
				"externalResources",
				"tags",
				"revision",
				"revisionTs",
				"guid",
				"baseIds",
				"checklistId",
				"lang",
				"contributors",
				"cloned",
				"authorProperties",
				"heroImage",
				"heroImageUrl",
				"trackData",
				"trackLocation",
				"dependencies",
				"privacy",
				"orgPrivacy",
				"visible",
				"suppressAudio",
				"hasShares"
			]
		}
	}
};

export const codeMirrorOptionsJson = constants.codeMirrorOptionsJson;
export const codeMirrorOptionsJs = constants.codeMirrorOptionsJs;

export default constants;
